import { render, staticRenderFns } from "./purchasecensus.vue?vue&type=template&id=6ad94300&scoped=true&"
import script from "./purchasecensus.vue?vue&type=script&lang=js&"
export * from "./purchasecensus.vue?vue&type=script&lang=js&"
import style0 from "./purchasecensus.vue?vue&type=style&index=0&id=6ad94300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad94300",
  null
  
)

export default component.exports